const i18nConfig = {
  locales: [process.env.NEXT_PUBLIC_DEFAULT_LOCALE],
  defaultLocale: process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
};

module.exports = i18nConfig;
